var map = {
	"./views/admin/backgroundAccount": [
		"3c4f",
		"chunk-7b83bf74",
		"chunk-9f25dbba"
	],
	"./views/admin/backgroundAccount.vue": [
		"3c4f",
		"chunk-7b83bf74",
		"chunk-9f25dbba"
	],
	"./views/admin/userAccount": [
		"dfd2",
		"chunk-6361ff43"
	],
	"./views/admin/userAccount.vue": [
		"dfd2",
		"chunk-6361ff43"
	],
	"./views/components/cascadeRegion": [
		"a5a6",
		"chunk-2d208bdf"
	],
	"./views/components/cascadeRegion.vue": [
		"a5a6",
		"chunk-2d208bdf"
	],
	"./views/components/map/mapSelect": [
		"52c8",
		"chunk-5554379f"
	],
	"./views/components/map/mapSelect.vue": [
		"52c8",
		"chunk-5554379f"
	],
	"./views/components/uploadDocument": [
		"2d75",
		"chunk-7b83bf74",
		"chunk-2d0bd9c6"
	],
	"./views/components/uploadDocument.vue": [
		"2d75",
		"chunk-7b83bf74",
		"chunk-2d0bd9c6"
	],
	"./views/components/uploadList": [
		"03f1",
		"chunk-7b83bf74",
		"chunk-b961c86c"
	],
	"./views/components/uploadList.vue": [
		"03f1",
		"chunk-7b83bf74",
		"chunk-b961c86c"
	],
	"./views/components/uploadVideo": [
		"998e",
		"chunk-7b83bf74",
		"chunk-2d0e6743"
	],
	"./views/components/uploadVideo.vue": [
		"998e",
		"chunk-7b83bf74",
		"chunk-2d0e6743"
	],
	"./views/dashboard": [
		"9406",
		"chunk-b5224aaa"
	],
	"./views/dashboard/": [
		"9406",
		"chunk-b5224aaa"
	],
	"./views/dashboard/index": [
		"9406",
		"chunk-b5224aaa"
	],
	"./views/dashboard/index.vue": [
		"9406",
		"chunk-b5224aaa"
	],
	"./views/error/401": [
		"ec55",
		"chunk-5edb3fc2"
	],
	"./views/error/401.vue": [
		"ec55",
		"chunk-5edb3fc2"
	],
	"./views/error/404": [
		"2754",
		"chunk-75424564"
	],
	"./views/error/404.vue": [
		"2754",
		"chunk-75424564"
	],
	"./views/info": [
		"e37e",
		"chunk-031943cc"
	],
	"./views/info/": [
		"e37e",
		"chunk-031943cc"
	],
	"./views/info/index": [
		"e37e",
		"chunk-031943cc"
	],
	"./views/info/index.vue": [
		"e37e",
		"chunk-031943cc"
	],
	"./views/layout/Empty": [
		"eefe",
		"chunk-2d231255"
	],
	"./views/layout/Empty.vue": [
		"eefe",
		"chunk-2d231255"
	],
	"./views/layout/Layout": [
		"d9ce"
	],
	"./views/layout/Layout.vue": [
		"d9ce"
	],
	"./views/layout/components": [
		"38e2"
	],
	"./views/layout/components/": [
		"38e2"
	],
	"./views/layout/components/AppMain": [
		"177e"
	],
	"./views/layout/components/AppMain.vue": [
		"177e"
	],
	"./views/layout/components/Navbar": [
		"a10a"
	],
	"./views/layout/components/Navbar.vue": [
		"a10a"
	],
	"./views/layout/components/Settings": [
		"e9a9"
	],
	"./views/layout/components/Settings/": [
		"e9a9"
	],
	"./views/layout/components/Settings/index": [
		"e9a9"
	],
	"./views/layout/components/Settings/index.vue": [
		"e9a9"
	],
	"./views/layout/components/Sidebar": [
		"30c6"
	],
	"./views/layout/components/Sidebar/": [
		"30c6"
	],
	"./views/layout/components/Sidebar/Item": [
		"b2c3"
	],
	"./views/layout/components/Sidebar/Item.vue": [
		"b2c3"
	],
	"./views/layout/components/Sidebar/Logo": [
		"399b"
	],
	"./views/layout/components/Sidebar/Logo.vue": [
		"399b"
	],
	"./views/layout/components/Sidebar/SidebarItem": [
		"e9ca"
	],
	"./views/layout/components/Sidebar/SidebarItem.vue": [
		"e9ca"
	],
	"./views/layout/components/Sidebar/index": [
		"30c6"
	],
	"./views/layout/components/Sidebar/index.vue": [
		"30c6"
	],
	"./views/layout/components/TagsView": [
		"9bb8"
	],
	"./views/layout/components/TagsView/": [
		"9bb8"
	],
	"./views/layout/components/TagsView/ScrollPane": [
		"a3f8"
	],
	"./views/layout/components/TagsView/ScrollPane.vue": [
		"a3f8"
	],
	"./views/layout/components/TagsView/index": [
		"9bb8"
	],
	"./views/layout/components/TagsView/index.vue": [
		"9bb8"
	],
	"./views/layout/components/index": [
		"38e2"
	],
	"./views/layout/components/index.js": [
		"38e2"
	],
	"./views/layout/mixin/ResizeHandler": [
		"6777"
	],
	"./views/layout/mixin/ResizeHandler.js": [
		"6777"
	],
	"./views/login": [
		"9ed6",
		"chunk-1ac900b6"
	],
	"./views/login/": [
		"9ed6",
		"chunk-1ac900b6"
	],
	"./views/login/index": [
		"9ed6",
		"chunk-1ac900b6"
	],
	"./views/login/index.vue": [
		"9ed6",
		"chunk-1ac900b6"
	],
	"./views/newsCenter": [
		"3465",
		"chunk-7b83bf74",
		"chunk-0b13b1ee",
		"chunk-aedededc"
	],
	"./views/newsCenter/": [
		"3465",
		"chunk-7b83bf74",
		"chunk-0b13b1ee",
		"chunk-aedededc"
	],
	"./views/newsCenter/index": [
		"3465",
		"chunk-7b83bf74",
		"chunk-0b13b1ee",
		"chunk-aedededc"
	],
	"./views/newsCenter/index.vue": [
		"3465",
		"chunk-7b83bf74",
		"chunk-0b13b1ee",
		"chunk-aedededc"
	],
	"./views/redirect": [
		"ef3c",
		"chunk-2d230fe7"
	],
	"./views/redirect/": [
		"ef3c",
		"chunk-2d230fe7"
	],
	"./views/redirect/index": [
		"ef3c",
		"chunk-2d230fe7"
	],
	"./views/redirect/index.vue": [
		"ef3c",
		"chunk-2d230fe7"
	],
	"./views/system/miniProgramAdvertising/bannerSetting": [
		"9b57",
		"chunk-7b83bf74",
		"chunk-432c952c"
	],
	"./views/system/miniProgramAdvertising/bannerSetting.vue": [
		"9b57",
		"chunk-7b83bf74",
		"chunk-432c952c"
	],
	"./views/system/permissionSetting/menuManagement": [
		"2b8ce",
		"chunk-7b83bf74",
		"chunk-746e7ff4"
	],
	"./views/system/permissionSetting/menuManagement.vue": [
		"2b8ce",
		"chunk-7b83bf74",
		"chunk-746e7ff4"
	],
	"./views/system/permissionSetting/roleManagement": [
		"7375",
		"chunk-7b83bf74",
		"chunk-3c42e0ba"
	],
	"./views/system/permissionSetting/roleManagement.vue": [
		"7375",
		"chunk-7b83bf74",
		"chunk-3c42e0ba"
	],
	"./views/tradingCenter/carbonData": [
		"e2c1",
		"chunk-7b83bf74",
		"chunk-2d225251"
	],
	"./views/tradingCenter/carbonData/": [
		"e2c1",
		"chunk-7b83bf74",
		"chunk-2d225251"
	],
	"./views/tradingCenter/carbonData/index": [
		"e2c1",
		"chunk-7b83bf74",
		"chunk-2d225251"
	],
	"./views/tradingCenter/carbonData/index.vue": [
		"e2c1",
		"chunk-7b83bf74",
		"chunk-2d225251"
	],
	"./views/tradingCenter/paymentAllocation/bankTransfer": [
		"0230",
		"chunk-7b83bf74",
		"chunk-d3ce94a2"
	],
	"./views/tradingCenter/paymentAllocation/bankTransfer.vue": [
		"0230",
		"chunk-7b83bf74",
		"chunk-d3ce94a2"
	],
	"./views/tradingCenter/paymentAllocation/virtualCurrency": [
		"31f9",
		"chunk-7b83bf74",
		"chunk-f7837d46"
	],
	"./views/tradingCenter/paymentAllocation/virtualCurrency.vue": [
		"31f9",
		"chunk-7b83bf74",
		"chunk-f7837d46"
	],
	"./views/tradingCenter/tradingOrder": [
		"5e30",
		"chunk-7b83bf74",
		"chunk-2d4ad121"
	],
	"./views/tradingCenter/tradingOrder.vue": [
		"5e30",
		"chunk-7b83bf74",
		"chunk-2d4ad121"
	],
	"./views/transactionContract/contract": [
		"334c",
		"chunk-7b83bf74",
		"chunk-0b13b1ee",
		"chunk-4e2065c1"
	],
	"./views/transactionContract/contract.vue": [
		"334c",
		"chunk-7b83bf74",
		"chunk-0b13b1ee",
		"chunk-4e2065c1"
	],
	"./views/user": [
		"e382",
		"chunk-b4d0271e"
	],
	"./views/user/": [
		"e382",
		"chunk-b4d0271e"
	],
	"./views/user/index": [
		"e382",
		"chunk-b4d0271e"
	],
	"./views/user/index.vue": [
		"e382",
		"chunk-b4d0271e"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2a68";
module.exports = webpackAsyncContext;